import { Pipe, PipeTransform } from '@angular/core'
import { ReviewCategoryRatingType } from '@tokeet-frontend/reviews'

@Pipe({ name: 'reviewCategory' })
export class ReviewCategoryPipe implements PipeTransform {
  transform(category: string) {
    switch (category) {
      case ReviewCategoryRatingType.FACILITIES:
        return $localize`Facilities`
      case ReviewCategoryRatingType.SERVICES:
        return $localize`Services`
      case ReviewCategoryRatingType.STAFF:
        return $localize`Staff`
      case ReviewCategoryRatingType.COMFORT:
        return $localize`Comfort`
      case ReviewCategoryRatingType.CLEANLINESS:
        return $localize`Cleanliness`
      case ReviewCategoryRatingType.COMMUNICATION:
        return $localize`Communication`
      case ReviewCategoryRatingType.RESPECT_HOUSE_RULES:
        return $localize`Respect House Rules`
      case ReviewCategoryRatingType.ACCURACY:
        return $localize`Accuracy`
      case ReviewCategoryRatingType.CHECKIN:
        return $localize`Checkin`
      case ReviewCategoryRatingType.LOCATION:
        return $localize`Location`
      case ReviewCategoryRatingType.VALUE:
        return $localize`Value`
      case ReviewCategoryRatingType.ONLINE_LISTING:
        return $localize`Online Listing`
      case ReviewCategoryRatingType.ROOM_CLEANLINESS:
        return $localize`Room Cleanliness`
      case ReviewCategoryRatingType.HOTEL_CONDITION:
        return $localize`Hotel Condition`
      case ReviewCategoryRatingType.ECO_FRIENDLINESS:
        return $localize`Eco Friendliness`
      case ReviewCategoryRatingType.AREA_AROUND_HOTEL:
        return $localize`Area Around Hotel`
      case ReviewCategoryRatingType.ROOM_AMENITIES_SCORE:
        return $localize`Room Amenities Score`
      case ReviewCategoryRatingType.NEIGHBORHOOD_SATISFACTION:
        return $localize`Neighborhood Satisfaction`
      case ReviewCategoryRatingType.CONVENIENCE_OF_LOCATION:
        return $localize`Convenience Of Location`
      case ReviewCategoryRatingType.ROOM_QUALITY:
        return $localize`Room Quality`
    }
  }
}
